const fileInputs = [...document.querySelectorAll('input[type="file"]')];
const actions    = [...document.querySelectorAll('.action')];

fileInputs.forEach((fileInput) => {
    fileInput.addEventListener('change', event => {
        const formGroup  = fileInput.closest('.form-group');
        const validation = formGroup.querySelector('.validation');
        const files      = event.target.files;
        const file       = files[0];

        console.log('filename: ${file.name}');
        console.log('file size: ${file.size} bytes');
        console.log('file type: ${file.type}');

        validation.innerHTML = '';
        formGroup.classList.remove('is-invalid');

        if ( file.size ) {
            fileInput.setAttribute('data-filesize', file.size);
        } else {
            fileInput.setAttribute('data-filesize', '');
        }
    });
});
